import { CloudComputingPowerServices } from 'network'

export const useCloudComputingPower = defineStore('cloudComputingPower', () => {
  const comboList = ref<CloudComputingPowerResponse.CloudGoods>({
    spotList: [],
    futuresList: [],
    calculator: {} as CloudComputingPowerResponse.Calculator,
    allList: [],
  } as CloudComputingPowerResponse.CloudGoods)
  const loadingGoods = ref(false)
  const miningConfig = ref<CloudComputingPowerResponse.MiningConfig[]>([])
  const rechargeElectricityVisible = ref(false)
  const activeType = ref<'' | 'spotList' | 'futuresList'>('')
  const activeOrderType = ref<'' | '1' | '2' | '3'>('')
  const orderList = ref<CloudComputingPowerResponse.CloudComputingPowerOrder[]>([])
  const electricityBillList = ref<CloudComputingPowerResponse.ElectricityBill[]>([])
  const orderDetailDailyList = ref<CloudComputingPowerResponse.CloudComputingPowerOrderDailyDetail[]>([])

  const orderStatusMap: Record<string, { label: string; class: string }> = {
    1: {
      label: '已预定',
      class: 'order',
    },
    2: {
      label: '挖矿中',
      class: 'ing',
    },
    3: {
      label: '挖矿结束',
      class: 'done',
    },
    4: {
      label: '暂停挖矿',
      class: 'stop',
    },
  }
  const electricityBillTypeMap: Record<string, { label: string; class: string }> = {
    1: {
      label: '主动充值',
      class: 'order',
    },
    2: {
      label: '自动续费',
      class: 'ing',
    },
    3: {
      label: '电费消耗',
      class: 'done',
    },
  }
  const fetchComboList = async () => {
    loadingGoods.value = true
    const { status, data } = await CloudComputingPowerServices.getComboList()
    if (status === 200) {
      comboList.value = data
      if (!comboList.value.futuresList) {
        comboList.value.futuresList = []
      }
    }
    loadingGoods.value = false
  }

  const currentTypeGoods = computed<CloudComputingPowerResponse.Goods[]>(() => {
    if (activeType.value === '') {
      return comboList.value.allList || []
    }
    return comboList.value[activeType.value]
  })
  const close = () => {
    rechargeElectricityVisible.value = false
  }
  const loadExternalConfig = async () => {
    const { status, data } = await CloudComputingPowerServices.getMiningConfig()
    if (status === 200) {
      miningConfig.value = data.sort((a, b) => -a.sort + b.sort)
    }
  }
  const getActiveMiningConfig = (miningType: number) => {
    return miningConfig.value.find((item) => item.miningType === miningType)
  }
  return {
    loadingGoods,
    miningConfig,
    loadExternalConfig,
    getActiveMiningConfig,
    rechargeElectricityVisible,
    electricityBillTypeMap,
    close,
    activeType,
    activeOrderType,
    currentTypeGoods,
    comboList,
    electricityBillList,
    fetchComboList,
    orderList,
    orderDetailDailyList,
    orderStatusMap,
  }
})
